export default {
      id: "fish-2-usage",
      viewBox: "0 0 124 68",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#fish-2",
      toString: function () {
        return this.url;
      }
    }